import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from './Navbar'
import './Learning.css'

export default function Learning({ setToken }) {
  const navigate = useNavigate()
  
  const [modules] = useState([
    {
      id: 1,
      name: 'Wirtschaft',
      slug: 'wirtschaft',
      description: 'Wirtschaftliche Grundlagen und Geschäftsprozesse',
      icon: '💼'
    },
    {
      id: 2,
      name: 'Ganzheitliche Aufgabe I (Betriebswirtschaftlich-technisch)',
      slug: 'lernfeld-4',
      description: 'Ganzheitliche Aufgabe I (Betriebswirtschaftlich-technisch) - Spezifische Inhalte',
      icon: '📚'
    },
    {
      id: 3,
      name: 'Ganzheitliche Aufgabe II (Technisch-anwendungsorientiert)',
      slug: 'lernfeld-6',
      description: 'Ganzheitliche Aufgabe II (Technisch-anwendungsorientiert) - Spezifische Inhalte',
      icon: '🎓'
    }
  ])

  const handleLogout = () => {
    localStorage.removeItem('token')
    setToken(null)
    navigate('/login', { replace: true })
  }

  const handleStatistikClick = () => {
    navigate('/statistik')
  }

  const handleAccountClick = () => {
    navigate('/account')
  }

  const handleBackToDashboard = () => {
    navigate('/dashboard')
  }

  const handleModuleSelect = (module) => {
    if (module.slug === 'wirtschaft') {
      navigate(`/learning/${module.slug}`, {
        state: { moduleTitle: module.name }
      });
    } else {
      navigate(`/learning/${module.slug}/topics`, {
        state: { moduleTitle: module.name }
      });
    }
  }

  return (
    <div className="learning">
      <div className="background" />
      
      <Navbar 
        title="Lernmodule"
        onLogout={handleLogout}
        logoClickable={true}
        onLogoClick={handleBackToDashboard}
        onStatistikClick={handleStatistikClick}
        onAccountClick={handleAccountClick}
      />

      {/* Hauptinhalt */}
      <div className="learning-content">
        <div className="learning-container">
          <div className="learning-header">
            <h2>Wählen Sie ein Lernmodul</h2>
            <p>Klicken Sie auf ein Modul, um mit den Lernaufgaben zu beginnen</p>
          </div>
          
          <div className="modules-grid">
            {modules.map(module => (
              <div key={module.id} className="module-card">
                <div className="module-icon">{module.icon}</div>
                <h3>{module.name}</h3>
                <p>{module.description}</p>
                <button 
                  onClick={() => handleModuleSelect(module)}
                  className="module-button"
                >
                  Modul starten
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}